import React, { useCallback, useEffect } from 'react';

import { Container } from './styles';

declare global {
  interface Window {
    UbotsWC?: {
      init: (options: object) => void;
      openChat: () => void;
      destroySession: () => void;
    };
  }
}

const REMOTE_CONFIG =
  'https://ubots-webchat.s3.amazonaws.com/prod/config/Unicred-317c21be-f5c2-4654-a1c8-3e3c0a3d3972.json';

const buildInternalUserPayload = (user: any) => ({
  id: `${user.identificadorEmpresa}`,
  name: `${user.identificadorEmpresa}`,
  identificadorEmpresa: `${user.identificadorEmpresa}`,
  layout: `${user.layout}`,
  produto: `${user.roles[0]}`,
});

const buildExternalUserPayload = (user: any) => ({
  id: `${user.agencia}-${user.conta}`,
  name: `${user.agencia}-${user.conta}`,
  agencia: `${user.agencia}`,
  conta: `${user.conta}`,
  cooperativa: `${user.cooperativa}`,
  produto: `${user.roles[0]}`,
});

export const UbotsChatButton: React.FC = () => {
  const initChat = useCallback(() => {
    if (!window.UbotsWC) return;
    try {
      const rawUser = localStorage.getItem('@PortalUnicred/user');
      if (!rawUser) return;

      const user = JSON.parse(rawUser);
      const isInternal = user.agencia === null && user.conta === null;
      const userPayload = isInternal
        ? buildInternalUserPayload(user)
        : buildExternalUserPayload(user);

      window.UbotsWC.init({
        user: userPayload,
        remoteConfiguration: REMOTE_CONFIG,
      });
    } catch (error) {
      console.error('[UbotsChat] Falha ao inicializar sessão:', error);
    }
  }, []);

  useEffect(() => {
    initChat();
    return () => {
      window.UbotsWC?.destroySession();
    };
  }, [initChat]);

  const handleOpenChat = () => {
    window.UbotsWC?.openChat();
  };

  return (
    <Container onClick={handleOpenChat} aria-label="Abrir chat">
      <img src={`${process.env.PUBLIC_URL}/assets/icons/ic_chat.svg`} alt="" />
    </Container>
  );
};
